module.exports = __webpack_public_path__ + "img/upcoming-events_ncaa.1cdca67f.jpg";